<script lang="ts">
    import type {SimpleFond} from 'src/typings';
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {pipe} from 'core/utils';
    import {loc} from 'src/shared/utils/pipes';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let icon: UIcons;
    export let fond: SimpleFond;
</script>

<div class="record-icon-container" use:tooltip={pipe(fond, loc())}>
    <UIcon {icon}/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    @record-icon-size: 56px;

    .record-icon-container {
        width: @record-icon-size;
        height: @record-icon-size;
        border-radius: @border-radius-large;
        border: 1px solid @themed-border-default;
        background-color: @themed-body-bg-orange-highlighted;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: var(--brand-orange);
    }
</style>